export const gamesEnum = Object.freeze({
  valorant: 'VALORANT',
  lol: 'LOL',
  fortnite: 'FORTNITE',
});

export const availableGames = Object.values(gamesEnum);
